import loginAPI from '@/api/login'
import comApi from '@/api/comApi.js'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus
    }
  },
  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        loginAPI.userLogin(userInfo).then(res => {
          setToken(res.result, rememberMe)
          commit('SET_TOKEN', res.result)
          // setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          // commit('SET_LOAD_MENUS', true)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    // GetInfo ({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     infoAPI.getPersonalInfo().then(res => {
    //       var mresult = {
    //         user: res.result,
    //         roles: ['admin']
    //       }
    //       setUserInfo(mresult, commit)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        comApi.getMerchant().then((res) => {
          let result
          let agentCost
          let code = res.code
          let msg = res.msg
          if (res.code === 0) {
            result = res.result.merchant
            agentCost = res.result.agentCost
          }
          var mresult = {
            user: result,
            roles: ['admin'],
            code: code,
            msg: msg,
            agentCost: agentCost
          }
          setUserInfo(mresult, commit)
          resolve(mresult)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut ({ commit }) {
      return new Promise((resolve, reject) => {
        loginAPI.logout().then(res => {
          logOut(commit)
          resolve()
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    },
    updateLoadMenus ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS', false)
      })
    }
  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  removeToken()
  window.location.reload()
}

export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  } else {
    commit('SET_ROLES', res.roles)
  }
  commit('SET_USER', res.user)
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js